import React from "react";

const features = [
  {
    icon: (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
        <path
          d="M9 17c-2.5 0-5-1-6-2 1-1 3-1 4 0m4.5-2.5c1.8-1.8 3-4.2 3-7 0-1-.2-2-.6-2.9C12 5 9.6 6.2 7.8 8c-2.8 2.8-4 6.5-3 9.5 3 1 6.7-.2 9.5-3z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="15" cy="8" r="1.4" fill="currentColor" />
        <path d="M9 20c0-2 1-3.5 2-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    ),
    title: "Innovative Products",
    desc: "Built for the future.",
    popup: "Cutting-edge tech, always evolving",
  },
  {
    icon: (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
        <path
          d="M13 4l7 3v6c0 5-3 8.5-7 10-4-1.5-7-5-7-10V7l7-3z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
        <path d="M9.5 13l2.3 2.3L17 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: "Secure & Reliable",
    desc: "Your data, our priority.",
    popup: "Bank-grade encryption & uptime",
  },
  {
    icon: (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
        <path d="M6 14v-2a7 7 0 0 1 14 0v2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <rect x="4" y="13" width="4" height="6" rx="2" fill="currentColor" opacity="0.85" />
        <rect x="18" y="13" width="4" height="6" rx="2" fill="currentColor" opacity="0.85" />
        <path d="M8 19v1a4 4 0 0 0 4 4h1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    ),
    title: "Dedicated Support",
    desc: "Always here for you.",
    popup: "Real humans, 24/7 response",
  },
  {
    icon: (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
        <circle cx="13" cy="8" r="3.4" fill="currentColor" />
        <path d="M6 21c0-3.6 3.1-6.4 7-6.4s7 2.8 7 6.4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        <circle cx="20" cy="10" r="2.2" fill="currentColor" opacity="0.55" />
        <path d="M22.5 18.5c-.2-2.2-1.7-3.9-3.7-4.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.55" />
      </svg>
    ),
    title: "Customer Focused",
    desc: "Your success matters.",
    popup: "Built around your feedback",
  },
];

function Feature() {
  return (
    <>
      <section className="pt80 pb80 feature-section">
        <div className="container">
          <div className="row mb40">
            <div className="col-12">
              <div className="feature-header">
                <span className="section-eyebrow">Why Choose Us</span>
                <h2 className="section-title">Everything You Need, In One Place</h2>
                <p className="section-subtitle">
                  We deliver high-quality products, 24/7 support and real value to our customers.
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            {features.map((item, index) => (
              <div key={item.title} className="col-lg-3 col-md-6 mb30">
                <div
                  className="feature-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="feature-popup">
                    {item.popup}
                    <span className="feature-popup-arrow" />
                  </div>

                  <span className="feature-shine" />
                  <div className="feature-icon">{item.icon}</div>
                  <div className="feature-text">
                    <h4>{item.title}</h4>
                    <p>{item.desc}</p>
                  </div>
                  <span className="feature-arrow">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <style>{`
        .feature-section {
          position: relative;
          overflow: hidden;
          background: linear-gradient(160deg, #0d0420 0%, #150836 50%, #1a0a42 100%);
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
        }
        .feature-section::before {
          content: "";
          position: absolute;
          top: -140px;
          right: -120px;
          width: 420px;
          height: 420px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(168,85,247,0.22), transparent 70%);
          z-index: 0;
        }
        .feature-section::after {
          content: "";
          position: absolute;
          bottom: -160px;
          left: -100px;
          width: 380px;
          height: 380px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(124,58,237,0.18), transparent 70%);
          z-index: 0;
        }
        .feature-section .container {
          position: relative;
          z-index: 1;
        }

        /* ── HEADER BLOCK ── */
        .feature-header {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }

        .section-eyebrow {
          display: inline-block;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.14em;
          color: #fff;
          background: rgba(255,255,255,0.14);
          border: 1px solid rgba(168,85,247,0.35);
          border-radius: 20px;
          padding: 6px 14px;
          margin-bottom: 14px;
        }

        /* ── UNIFIED HEADING (left-aligned) ── */
        .section-title {
          font-family: 'Outfit', sans-serif;
          font-size: clamp(2.1rem, 4vw, 3rem);
          font-weight: 800;
          line-height: 1.15;
          color: #fff;
          margin: 0 0 12px;
          align-self: flex-start;
          text-align: left;
        }

        /* ── UNIFIED SUBHEADING (left-aligned) ── */
        .section-subtitle {
          font-family: 'Inter', sans-serif;
          font-size: 15.5px;
          font-weight: 400;
          line-height: 1.75;
          color: #d8cdea;
          margin-bottom: 0;
          max-width: 520px;
          align-self: flex-start;
          text-align: left;
        }

        /* ── CARD BASE ── */
        .feature-card {
          position: relative;
          isolation: isolate;
          overflow: hidden;
          background: #ffffff;
          border-radius: 14px;
          padding: 24px 20px;
          display: flex;
          align-items: center;
          gap: 14px;
          height: 100%;
          border: 1px solid rgba(124,58,237,0.08);
          box-shadow: 0 10px 26px rgba(10,4,32,0.35);
          transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),
                      box-shadow 0.35s cubic-bezier(0.22, 1, 0.36, 1),
                      border-color 0.35s ease,
                      background 0.35s ease;
          opacity: 0;
          transform: translateY(20px);
          animation: reveal 0.7s ease forwards;
          cursor: pointer;
        }

        .feature-card::before {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(124,58,237,0.06), rgba(168,85,247,0.02));
          opacity: 0;
          transition: opacity 0.35s ease;
          z-index: -2;
        }

        .feature-shine {
          position: absolute;
          top: 0;
          left: -60%;
          width: 40%;
          height: 100%;
          background: linear-gradient(115deg, transparent, rgba(255,255,255,0.55), transparent);
          transform: skewX(-20deg);
          z-index: -1;
          transition: left 0.7s ease;
        }

        .feature-icon {
          flex-shrink: 0;
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: rgba(168, 85, 247, 0.15);
          color: #7c3aed;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.35s ease, color 0.35s ease, transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        .feature-text {
          flex: 1;
          min-width: 0;
        }
        .feature-text h4 {
          font-family: 'Outfit', sans-serif;
          font-size: 15.5px;
          font-weight: 700;
          color: #1f2937;
          margin: 0 0 4px;
          line-height: 1.3;
          transition: color 0.3s ease;
        }
        .feature-text p {
          font-family: 'Inter', sans-serif;
          font-size: 13px;
          color: #6b7280;
          margin: 0;
          transition: color 0.3s ease;
        }

        .feature-arrow {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          color: #7c3aed;
          background: rgba(124,58,237,0.08);
          opacity: 0;
          transform: translateX(-6px);
          transition: opacity 0.3s ease, transform 0.3s ease;
        }

        /* ── POPUP / TOOLTIP ── */
        .feature-popup {
          position: absolute;
          bottom: calc(100% + 12px);
          left: 50%;
          transform: translateX(-50%) translateY(6px);
          background: linear-gradient(135deg, #7c3aed, #6d28d9);
          color: #fff;
          font-size: 12.5px;
          font-weight: 600;
          white-space: nowrap;
          padding: 9px 16px;
          border-radius: 10px;
          box-shadow: 0 12px 24px rgba(109,40,217,0.4);
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
          z-index: 5;
        }
        .feature-popup-arrow {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-top: 6px solid #6d28d9;
        }

        /* ── HOVER / FOCUS STATE ── */
        .feature-card:hover,
        .feature-card:focus-visible {
          transform: translateY(-8px) scale(1.02);
          border-color: rgba(168,85,247,0.45);
          box-shadow: 0 22px 48px rgba(124,58,237,0.38), 0 0 0 1px rgba(168,85,247,0.15) inset;
        }
        .feature-card:hover::before,
        .feature-card:focus-visible::before {
          opacity: 1;
        }
        .feature-card:hover .feature-shine,
        .feature-card:focus-visible .feature-shine {
          left: 130%;
        }
        .feature-card:hover .feature-icon,
        .feature-card:focus-visible .feature-icon {
          background: linear-gradient(135deg, #7c3aed, #a855f7);
          color: #fff;
          transform: scale(1.1) rotate(-6deg);
        }
        .feature-card:hover .feature-text h4,
        .feature-card:focus-visible .feature-text h4 {
          color: #5b21b6;
        }
        .feature-card:hover .feature-arrow,
        .feature-card:focus-visible .feature-arrow {
          opacity: 1;
          transform: translateX(0);
        }
        .feature-card:hover .feature-popup,
        .feature-card:focus-visible .feature-popup {
          opacity: 1;
          transform: translateX(-50%) translateY(0);
        }
        .feature-card:active {
          transform: translateY(-4px) scale(0.99);
        }

        @keyframes reveal {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 767px) {
          .feature-popup {
            display: none;
          }
        }
      `}</style>
    </>
  );
}

export default Feature;